const SHIPMENT_MODES = {
  1: "land",
  2: "air",
  3: "sea",
};

function normalizeShipmentMode(mode) {
  if (mode === null || mode === undefined) {
    return "land";
  }

  const normalizedMode = String(mode).trim().toLowerCase();
  return SHIPMENT_MODES[normalizedMode] || normalizedMode;
}

export function getOperatorLabel(mode) {
  switch (normalizeShipmentMode(mode)) {
    case "air":
      return "Carrier Operator Name";
    case "sea":
      return "Vessel Operator Name";
    default:
      return "Driver Name";
  }
}

export function getUnitNoLabel(mode) {
  switch (normalizeShipmentMode(mode)) {
    case "air":
      return "Flight No.";
    case "sea":
      return "Vessel No.";
    default:
      return "Truck No.";
  }
}

export function getOperatorRoleLabel(mode) {
  return getOperatorLabel(mode).replace(/ Name$/, "");
}

export function getUnitLabel(mode) {
  switch (normalizeShipmentMode(mode)) {
    case "air":
      return "Flight";
    case "sea":
      return "Vessel";
    default:
      return "Truck";
  }
}

export function getOperatorDetailsLabel(mode) {
  return `${getOperatorRoleLabel(mode)} Details`;
}

export function getOperatorIdLabel(mode) {
  return `${getOperatorRoleLabel(mode)} ID`;
}

export function getOwnerOperatorsLabel(mode) {
  return `Owner ${getOperatorRoleLabel(mode)}s`;
}

export function getAssignOperatorLabel(mode) {
  return `Assign ${getOperatorRoleLabel(mode)}`;
}

export function getOperatorAssignmentLabel(mode) {
  return `${getOperatorRoleLabel(mode)} Assignment`;
}

export function getOperatorAmountLabel(mode) {
  return `${getOperatorRoleLabel(mode)} Amount`;
}

export function getOperatorPriceLabel(mode) {
  return `${getOperatorRoleLabel(mode)} Price`;
}

export function getOperatorDocumentProofLabel(mode) {
  return `${getOperatorRoleLabel(mode)} Physical Doc Proof`;
}

export function getUnitTypeLabel(mode) {
  return `${getUnitLabel(mode)} Type`;
}

export function getUnitDetailsLabel(mode) {
  return `${getUnitLabel(mode)} Details`;
}

export function getShipmentIcon(mode) {
  switch (normalizeShipmentMode(mode)) {
    case "air":
      return "flight";
    case "sea":
      return "directions_boat";
    default:
      return "local_shipping";
  }
}

export function getModeIcon(mode) {
  switch (normalizeShipmentMode(mode)) {
    case "air":
      return "flight_takeoff";
    case "sea":
      return "directions_boat";
    default:
      return "local_shipping";
  }
}
